/* eslint-disable react/prop-types */
import React from 'react';
import { Form, Button, Row, Col, Switch } from 'antd';
import PropTypes from 'prop-types';
import { RegexInput } from 'shared_components/pattern_input'
import { UserAccessContext } from 'context/userAccess';
import showDeactivationModal from 'shared_components/deactivation_modal';
import { deactivateItem } from 'services/settings/status';
import { fieldLabels, formMode, buttonNames, fieldRules} from '../../settings';

import './fillup_form.css';

class FillupForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isForceDeactivate: false,
		}

		this.formRef = React.createRef();
	}

	componentDidMount() {
		const { rangeClass, moduleType } = this.props;

		// Only set field values in UPDATE mode
		if (moduleType === formMode.update) {
			const { rangeClassLabel, active } = rangeClass;
			this.formRef.current.setFieldsValue({ rangeClassLabel, active: active === 1 });
		}
	}

	componentDidUpdate(prevProps) {
		const { rangeClass, moduleType } = this.props;

		// Only update fields in UPDATE mode
		if (moduleType === formMode.update && rangeClass.rangeClassID !== prevProps.rangeClass.rangeClassID) {
			const { rangeClassLabel, active } = rangeClass;
			this.formRef.current.setFieldsValue({ rangeClassLabel, active: active === 1 });
		}
	}

	onFormSubmit = (fieldValues) => {
		const { onSubmit, moduleType, rangeClass } = this.props;

		this.setState({ isLoading: true }, async() => {
			if (moduleType === formMode.update && fieldValues.active === false && this.state.isForceDeactivate) {
				await deactivateItem('Range Class Label', rangeClass.rangeClassID);
			}

			await onSubmit({ ...fieldValues, active: fieldValues.active ? 1 : 0 });

			this.setState({ isLoading: false, isForceDeactivate: false });
		});
	}

	onChangeRelease = (isSelected) => {
		const { form } = this.props;

		if(!isSelected)
			form.setFieldsValue({ autoRelease: false });
	}

	resetForm = () => {
		// eslint-disable-next-line react/prop-types
		const { resetFields } = this.formRef.current;

		resetFields();
	}

	render() {
		const { isLoading } = this.state;
		const { 
			onClose, 
			moduleType,
		} = this.props;

		return (
			<Form 
				ref={this.formRef}
				onFinish={this.onFormSubmit} 
				className="label-class-fillup-form"
				layout="vertical"
			>
				<section style={{ marginBottom: 50 }}>
					<section className="form-values">
						{
							(moduleType === formMode.update) ?
							(
								<Row align="middle">
									<Col span={22}>
										STATUS:
									</Col>
									<Col span={22}>
										<Form.Item 
											name="active"
											valuePropName="checked"
										>
											<Switch 
												onChange={checked => {
													if (!checked) {
														const { rangeClass } = this.props;
														showDeactivationModal('Range Class Label', rangeClass.rangeClassID, {
															itemLabel: 'Range Class Label',
															onConfirm: isForce => {
																this.formRef.current.setFieldsValue({ active: false });
																this.setState({ isForceDeactivate: isForce });
															},
															onCancel: () => {
																this.formRef.current.setFieldsValue({ active: true });
																this.setState({ isForceDeactivate: false });
															},
														});
													}
												}}
											/>
										</Form.Item>
									</Col>
								</Row>
							)
							:
							(
								<Row align="middle">
									<Col span={22}>
										STATUS:
									</Col>
									<Col span={22}>
										<Form.Item 
											name="active"
											valuePropName="checked"
											initialValue={true}
										>
											<Switch disabled={true}/>
										</Form.Item>
									</Col>
								</Row>
							)
						}
						<Row style={{ marginTop: 10 }}>
							<Col span={12}>
								<Form.Item 
									name="rangeClassLabel"
									label={fieldLabels.ageRangeClassLabel}
									rules={fieldRules.ageBracketRangeLabel}
								>
									<RegexInput maxLength={254} regex={/[A-Za-z0-9 ]/}  />
								</Form.Item>
							</Col>
						</Row>
					</section>
				</section>
				<section className="drawerFooter">
					<div>
						<Button 
							shape="round" 
							style={{ margin: 10, width: 120 }}
							onClick={onClose}
						>
							{buttonNames.cancel}
						</Button>
						<UserAccessContext.Consumer>
									{value => value.userAccess.settings.create && (
						<Button 
							shape="round" 
							type="primary" 
							htmlType="submit"
							loading={isLoading}
							style={{ margin: 10, width: 120 }}
						>
							{(moduleType === formMode.add) ?  buttonNames.create : buttonNames.update}
						</Button>
							)}
							</UserAccessContext.Consumer>
					</div>
				</section>
			</Form>
		);
	}
}

FillupForm.propTypes = {
	moduleType: PropTypes.string.isRequired,
	rangeClass: PropTypes.shape({
		rangeClassID: PropTypes.number,
		rangeClassLabel: PropTypes.string
	}),
	onClose: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
};

FillupForm.defaultProps = {
	rangeClass: {
		rangeClassID: null,
		rangeClassLabel: null
	},
}


export default FillupForm;